import { defineComponent } from 'vue'

export default defineComponent({
  name: 'consent-toggle',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },

    locked: {
      type: Boolean,
      default: false,
    },
    inputId: {
      type: String,
      required: true,
    },
    describedby: {
      type: String,
      default: '',
    },
  },
  methods: {
    onChange(event) {
      if (this.locked) return
      this.$emit('change', event.target.checked)
    },
  },
})
